import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { ReactReduxContext } from 'react-redux';

import getInjectors from './epicsInjectors';

/**
 * Dynamically injects an array of epics, passes component's props as epics arguments
 *
 * @param {string} key A key of the epics
 * @param {array} epic An array of epics that will be injected
 *
 */
export default ({ key, epics }) =>
  (WrappedComponent) => {
    class InjectEpics extends React.Component {
      static WrappedComponent = WrappedComponent;

      constructor(props, context) {
        super(props, context);

        getInjectors(context.store).injectEpics(key, epics);
      }

      render() {
        return <WrappedComponent {...this.props} />;
      }
    }

    InjectEpics.contextType = ReactReduxContext;
    InjectEpics.displayName = `withEpics(${
      InjectEpics.WrappedComponent.displayName || InjectEpics.WrappedComponent.name || 'Component'
    })`;

    return hoistNonReactStatics(InjectEpics, WrappedComponent);
  };

const useInjectEpics = ({ key, epics }) => {
  const context = React.useContext(ReactReduxContext);
  React.useEffect(() => {
    // @NOTE-DP: disable epics in Storybook for now. Feel free to make this configurable when needed.
    if (!window.STORYBOOK_ENV) {
      getInjectors(context.store).injectEpics(key, epics);
    }
  }, []);
};

export { useInjectEpics };
